import React from 'react';
import RecRegistryCertificateGenerationsDataTable from './RecRegistryCertificateGenerationsDataTable'
import CertificateGenerationsFilterForm, { CertificateGenerationsFilterData } from './_components/CertificateGenerationsFilterForm'
import CertificateGenerationPage from './CertificateGenerationPage'
import {
  Switch,
  Route,
  Link as RouteLink,
  useRouteMatch,
} from 'react-router-dom';

const CertificateGenerations: React.FC = (): React.ReactElement => {
  const match = useRouteMatch()
  const [filter, setFilter] = React.useState({} as CertificateGenerationsFilterData)

  return (
    <Switch>
      <Route path={`${match.path}/:generationId`}>
        <CertificateGenerationPage />
      </Route>
      <Route>
        <CertificateGenerationsFilterForm filter={filter} setFilter={setFilter} />
        <RecRegistryCertificateGenerationsDataTable
          accreditationCodeId={filter.accreditationCode}
          generationYear={filter.generationYear}
          registeredPersonNumber={filter.registeredPersonNumber}
          containsErrors={filter.containsErrors}
        />
      </Route>
    </Switch>
  )
}

export default CertificateGenerations
